import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-events-security-service',
  imports: [RouterLink],
  templateUrl: './events-security-service.component.html',
  styleUrl: './events-security-service.component.scss',
})
export class EventsSecurityServiceComponent {

}
